module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_e-85ca59b65c4aebf92adb28b85cbff07c.png";